import Head from "next/head";
import Layout from "../components/Layout";
import Breadcrumb from "@/components/BreadCrumb";

export default function Terms() {
  return (
    <Layout>
      <Head>
        <title>Terms & Conditions | AstroLearn</title>
        <meta
          name="description"
          content="Review AstroLearn's terms and conditions for accessing our astrology courses. Learn about user responsibilities, policies, and service guidelines."
        />
      </Head>
      <section>
        <Breadcrumb classNames="absolute top-20 left-4 lg:left-20" />
        <div className="container prose my-10 max-md:mt-12">
          <h1>Terms and Conditions</h1>
          <p>
            By accessing this web site, you are agreeing to be bound by these
            web site Terms and Conditions of Use, all applicable laws and
            regulations, and agree that you are responsible for compliance with
            any applicable local laws. If you do not agree with any of these
            terms, you are prohibited from using or accessing this site. The
            materials contained in this web site are protected by applicable
            copyright and trade mark law.
          </p>
          <h2>Use License</h2>
          <ul className="list-none">
            <li>
              <p>
                A. Permission is granted to temporarily download one copy of the
                materials (information or software) on Company&apos;s web site
                for personal, non-commercial transitory viewing only. This is
                the grant of a license, not a transfer of title, and under this
                license you may not:
              </p>
              <ul className="list-none">
                <li>
                  <p>i. modify or copy the materials;</p>
                </li>
                <li>
                  <p>
                    ii. use the materials for any commercial purpose, or for any
                    public display (commercial or non-commercial);
                  </p>
                </li>
                <li>
                  <p>
                    iii. attempt to decompile or reverse engineer any software
                    contained on Company&apos;s web site;
                  </p>
                </li>
                <li>
                  <p>
                    iv. remove any copyright or other proprietary notations from
                    the materials; or
                  </p>
                </li>
                <li>
                  <p>
                    v. transfer the materials to another person or
                    &apos;mirror&apos; the materials on any other server.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                B. This license shall automatically terminate if you violate any
                of these restrictions and may be terminated by Company at any
                time. Upon terminating your viewing of these materials or upon
                the termination of this license, you must destroy any downloaded
                materials in your possession whether in electronic or printed
                format.
              </p>
            </li>
          </ul>
          <h2>Disclaimer</h2>
          <p>
            The materials on Company&apos;s web site are provided &apos;as
            is&apos;. Company makes no warranties, expressed or implied, and
            hereby disclaims and negates all other warranties, including without
            limitation, implied warranties or conditions of merchantability,
            fitness for a particular purpose, or non-infringement of
            intellectual property or other violation of rights. Further, Company
            does not warrant or make any representations concerning the
            accuracy, likely results, or reliability of the use of the materials
            on its Internet web site or otherwise relating to such materials or
            on any sites linked to this site.
          </p>
          <h2>Limitations</h2>
          <p>
            In no event shall Company or its suppliers be liable for any damages
            (including, without limitation, damages for loss of data or profit,
            or due to business interruption) arising out of the use or inability
            to use the materials on Company&apos;s Internet site, even if
            Company or a Company authorized representative has been notified
            orally or in writing of the possibility of such damage. Because some
            jurisdictions do not allow limitations on implied warranties, or
            limitations of liability for consequential or incidental damages,
            these limitations may not apply to you.
          </p>
          <h2>Revisions and Errata</h2>
          <p>
            The materials appearing on Company&apos;s web site could include
            technical, typographical, or photographic errors. Company does not
            warrant that any of the materials on its web site are accurate,
            complete, or current. Company may make changes to the materials
            contained on its web site at any time without notice. Company does
            not, however, make any commitment to update the materials.
          </p>
          <h2>Links</h2>
          <p>
            Company has not reviewed all of the sites linked to its Internet web
            site and is not responsible for the contents of any such linked
            site. The inclusion of any link does not imply endorsement by
            Company of the site. Use of any such linked web site is at the
            user&apos;s own risk.
          </p>
          <h2>Site Terms of Use Modifications</h2>
          <p>
            Company may revise these terms of use for its web site at any time
            without notice. By using this web site you are agreeing to be bound
            by the then current version of these Terms and Conditions of Use.
          </p>
          <h2>Governing Law</h2>

          <p>
            Any claim relating to Company&apos;s web site shall be governed by
            the laws of the India without regard to its conflict of law
            provisions.
          </p>
        </div>
      </section>
    </Layout>
  );
}
